<template>
  <div class="container">
    <el-dialog title="隐私协议" class="dialog-box" :visible.sync="privacyAgreement" width="1186px">
      <div v-html="showContent" class="rich-txt-box">

      </div>
    </el-dialog>


    <!-- 头部导航栏 -->
    <HeaderRegion ref="headerForm" :isShowIndex="-1"></HeaderRegion>

    <div class="main-box">
      <!--      基础信息-->
      <div class="line-title">
        <div class="line-title-txt">基础信息</div>
      </div>
      <div class="row-line">
        <div class="row-left">
          <div class="row-title-box">
            <span class="red-class">*</span>
            <div class="row-title">
              姓 名
            </div>
          </div>
          <el-input v-model="name" :disabled="userInfo.auditStatus==1|| userInfo.auditStatus==2" placeholder="请输入您的姓名"
                    class="input-class" :maxLength='30'></el-input>

        </div>
        <div class="row-right">
          <div class="row-title-box">
            <span class="red-class">*</span>
            <div class="row-title">
              性 别
            </div>
          </div>
          <el-radio v-model="sex" label="1" :disabled="userInfo.auditStatus==1|| userInfo.auditStatus==2">男</el-radio>
          <el-radio v-model="sex" label="0" :disabled="userInfo.auditStatus==1|| userInfo.auditStatus==2">女</el-radio>
        </div>
      </div>
      <div class="row-line">
              <div class="row-left">
                <div class="row-title-box">
                  <span class="red-class">*</span>
                  <div class="row-title">
                    身 份
                  </div>
                </div>
                <el-select v-model="identity" :disabled="userInfo.auditStatus==1|| userInfo.auditStatus==2" placeholder="请选择"
                           style="width: 300px;">
                  <el-option v-for="item in options" size="mini" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="row-right">
                <div class="row-title-box row-title-Bankbox">
                  <span class="red-class" v-show="identity == 3">*</span>
                  <div class="row-title" v-show="identity == 1 || identity == 3">
                    公司名称
                  </div>
                  <div class="row-title" v-show="identity == 2">
                    学校名称
                  </div>
                </div>
                <el-input v-model="belong" :disabled="userInfo.auditStatus==1|| userInfo.auditStatus==2"
                          :placeholder="identity == 2?'请输入您的学校名称':'请输入您的公司名称'" class="input-class" maxLength='30'></el-input>
              </div>
            </div>

            <div class="row-line">
              <div class="row-left">
                <div class="row-title-box">
                  <!-- <span class="red-class">*</span> -->
                  <div class="row-title">
                    邮 箱
                  </div>
                </div>
                <el-input v-model="email" :disabled="userInfo.auditStatus==1|| userInfo.auditStatus==2 || userInfo.emailStatus==1"
                          placeholder="请输入您的邮箱" class="input-class"></el-input>

                <button class="button-active" v-if="userInfo.emailStatus==0" @click="activeClick()">去激活</button>
                <button v-if="userInfo.emailStatus==1" :disabled="userInfo.auditStatus==1|| userInfo.auditStatus==2"
                        class="button-actived">已激活
                </button>
              </div>
              <div class="row-right">
                <div class="row-title-box">
                  <span class="red-class">*</span>
                  <div class="row-title">
                    工作经验
                  </div>
                </div>
                <el-select v-model="experience" :disabled="userInfo.auditStatus==1|| userInfo.auditStatus==2" placeholder="请选择"
                           style="width: 300px;">
                  <el-option v-for="item in designTime" size="mini" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>

            <div class="row-line">
                <div class="row-title-box">
                  <span class="red-class">*</span>
                  <div class="row-title">
                    个人强项(可多选)
                  </div>
                </div>
                <div class="gerTab">
                  <div
                    class="gerTr"
                    :class="selectStrengths.indexOf(item.id)>-1 ? 'gerTrs' : ''"
                    v-for="(item, index) in strengthsList"
                    @click="userInfo.auditStatus==1|| userInfo.auditStatus==2?'':showTab(item)"
                    :key="index"
                  >
                    {{ item.name }}
                  </div>
              </div>
            </div>

            <div class="row-line">
              <div class="row-title-box">
                <span class="red-class">*</span>
                <div class="row-title">
                  通讯地址
                </div>
              </div>
              <el-input v-model="addressDetail" :disabled="userInfo.auditStatus==1|| userInfo.auditStatus==2" maxlength="50"
                        placeholder="请输入您的通讯地址" class="input-class input-identityClass"></el-input>
            </div>

            <div class="row-line">
              <div class="row-title-box">
                <!-- <span class="red-class">*</span> -->
                <div class="row-title">
                  自我描述
                </div>
              </div>
              <el-input type="textarea" maxlength="200"
                        :disabled="userInfo.auditStatus==1|| userInfo.auditStatus==2" placeholder="请输入个人介绍"
                        v-model="detail" style="width: 900px;">
              </el-input>
            </div>

            <div class="row-line">
              <div class="row-left">
                <div class="row-title-box" style="width:600px;">
      <!--            <span class="red-class">*</span>-->
                  <div class="row-title">
                    获奖证书
                  </div>
                  <div style="display: flex;" @click="userInfo.auditStatus==1|| userInfo.auditStatus==2? '' : selectFile3()">
                    <input type="file" id="fileName3" @change="uploading($event)" style="display: none;"
                           accept="image/png,image/jpg"/>
                    <img :src="baseImgUrl+'/'+imageUrl3" v-if="imageUrl3" class='pdfImgs'>
                    <img class="pdfImg" src="../../../static/image/certInfo/upload.png" v-else>
                    <div class="row-title" style="color: #C7C7C7;font-size: 13px;">点击上传您的获奖证书扫描件</div>
                  </div>
                </div>
              </div>
            </div>


      <div class="line-title" style="margin-top: 67px;">
        <div class="line-title-txt">个人介绍</div>
      </div>
      <div class="row-line">
        <div class="row-title-box">
          <span class="red-class">*</span>
          <div class="row-title">
            证件类型
          </div>
        </div>

         <el-select v-model="idType" placeholder="请选择您的证件类型" :disabled="userInfo.auditStatus==1|| userInfo.auditStatus==2" >
            <el-option
              v-for="item in options2"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
      </div>

      <div class="row-line">
        <div class="row-title-box">
          <span class="red-class">*</span>
          <div class="row-title">
            证件号码
          </div>
        </div>
        <el-input v-model="idNumber" maxlength="18" :disabled="userInfo.auditStatus==1|| userInfo.auditStatus==2"
                  placeholder="请输入您的证件号码" class="input-class input-identityClass"></el-input>
      </div>

      <div class="row-lines">
        <div class="row-titleIdentityInfo">
          <div class="row-title">
            证件信息采集
          </div>
          <div class="imgItem">
            <div class="identityPhoto" @click="userInfo.auditStatus==1|| userInfo.auditStatus==2? '' : selectFile()">
              <input type="file" id="fileName" @change="uploading($event)" style="display: none;"
                     accept="image/png,image/jpg"/>
              <img :src="baseImgUrl+'/'+imageUrl" v-if="imageUrl" class='identity-img'>
              <img class="identity1" src="../../../static/image/certInfo/identity1.png" alt v-else/>
              <div class="text">点击上传证件人像面</div>
            </div>

            <div class="identityPhoto" @click="userInfo.auditStatus==1|| userInfo.auditStatus==2? '' : selectFile2()">
              <input type="file" id="fileName2" @change="uploading($event)" style="display: none;"
                     accept="image/png,image/jpg"/>
              <img :src="baseImgUrl+'/'+imageUrl2" v-if="imageUrl2" class='identity-img'>
              <img class="identity2" src="../../../static/image/certInfo/identity2.png" alt v-else/>
              <div class="text">点击上传证件反面</div>
            </div>
          </div>
        </div>
      </div>

      <div class="row-line">
        <div class="row-left">
          <div class="row-title-box">
            <!-- <span class="red-class">*</span> -->
            <div class="row-title">
              银行卡号
            </div>
          </div>
          <el-input v-model="bankNumber" :disabled="userInfo.auditStatus==1|| userInfo.auditStatus==2" maxlength="21"
                    placeholder="请输入银行卡号" class="input-class"></el-input>
        </div>
        <div class="row-right">
          <div class="row-title-box">
            <!-- <span class="red-class">*</span> -->
            <div class="row-title">
              开户银行
            </div>
          </div>
          <el-input v-model="bankName" :disabled="userInfo.auditStatus==1|| userInfo.auditStatus==2" maxlength="20"
                    placeholder="请输入开户银行" class="input-class"></el-input>
        </div>
      </div>

      <div class="row-line">
        <div class="row-left">
          <div class="row-title-box">
            <!-- <span class="red-class">*</span> -->
            <div class="row-title">
              开户省市
            </div>
          </div>
          <el-input v-model="bankBranch" :disabled="userInfo.auditStatus==1|| userInfo.auditStatus==2" maxlength="10"
                    placeholder="请输入开户省市" class="input-class"></el-input>
        </div>
        <div class="row-right">
          <div class="row-title-box">
            <!-- <span class="red-class">*</span> -->
            <div class="row-title">
              开户人姓名
            </div>
          </div>
          <el-input v-model="accountName" :disabled="userInfo.auditStatus==1|| userInfo.auditStatus==2" maxlength="20"
                    placeholder="请输入开户人姓名" class="input-class"></el-input>
        </div>
      </div>


      <div class="row-line" style="margin-top: 24px;">
        <div class="row-left">
          <div class="row-title-box" style="width: 360px;">
            <div style="color: #C7C7C7;font-size: 11px;width: 366px;height: 34px;">
              1.人工审核会在3个工作日内完成，审核结果会以站内信形式返回。
              2.请认真填写以上信息，确保准确无误。
            </div>
          </div>
        </div>
      </div>

      <div class="row-line" style="margin-top: 9px;">
        <div class="row-left">
          <div class="row-title-box" style="width: 180px;">
            <button id="show" @click='sureChange($event)' :disabled="userInfo.auditStatus==1|| userInfo.auditStatus==2"
                    class="sureButton"></button>
            <span style="color: #3A3A3A;font-size: 11px;margin-left: 10px;">请确定阅读</span>
            <span style="color: #658FFF;font-size: 11px;" @click="showPrivacy">《隐私协议》</span>
          </div>
        </div>
      </div>

      <div class="row-line">
        <button class="save" @click="goPreservation()" v-if="userInfo.auditStatus!=1 && userInfo.auditStatus!=2">仅保存
        </button>
        <button class="submitAudit" @click="change()" v-if="userInfo.auditStatus!=1 && userInfo.auditStatus!=2">
          提交审核
        </button>
      </div>
    </div>
    <!-- 底部展示区域 -->
    <BottomRegion ref="bottomForm"></BottomRegion>
  </div>
</template>

<script>
  import manage from "../../api/manage";

  import HeaderRegion from "../../components/headerRegion/headerRegion"; //引入头部导航栏
  import BottomRegion from "../../components/bottomRegion/bottomRegion"; //引入底部展示
  import {
    baseImgUrl
  } from "../../api/config"

  export default {
    name: "home",
    components: {
      HeaderRegion,
      BottomRegion,
    },
    data() {
      return {
        idType:'0',//证件类型
        options: [{
          value: '1',
          label: '设计师'
        }, {
          value: '2',
          label: '学生'
        }, {
          value: '3',
          label: '设计公司/工作室'
        }],
        options2: [
          {
            value: '0',
            label: '请选择'
          },
         {
          value: '1',
          label: '身份证'
        }, {
          value: '2',
          label: '通行证'
        }, {
          value: '3',
          label: '台胞证'
        },
        {
          value: '4',
          label: '护照'
        }],
        designTime: [
          {
            id: '',
            name: '请选择'
          },
          {
            id: '1',
            name: '0-3年(包含3年)'
          },
          {
            id: '2',
            name: '3-5年(包含5年)'
          },
          {
            id: '3',
            name: '5-8年(包含8年)'
          },
          {
            id: '4',
            name: '8年以上'
          },
        ],
        experience: '', //工作经验
        strengthsList: [], //个人强项
        selectStrengths: [],

        userInfo: {}, //用户信息
        isShow: false,
        showPhotos: 0,
        baseImgUrl: baseImgUrl,
        imageUrl: '',
        imageUrl2: '',
        imageUrl3: '',
        headerForm: 0,
        id: '', //id
        name: "", //设计师姓名
        sex: '', //性别(1男性，0女性）
        idNumber: '', //身份证号
        idFront: '', //身份证国徽面（正面）
        idReverse: '', //身份证人像面（反面）
        bankNumber: '', //银行卡卡号
        bankName: '', //开户银行
        bankBranch: '', //开户省市
        accountName: '', //开户人姓名
        identity: '', //身份(1设计师,2学生，3设计公司/工作室)
        belong: '', //所属公司/学校名称
        email: '', //邮箱地址
        addressDetail: '', //详细地址
        detail: '', //自我描述
        certificate: '', //获奖证书
        imgPaths: '', //图片地址
        privacyAgreement: false,
        showContent: "",
        emailStaus: '',
        timeout: null,
      };
    },
    created() {
      this.getPrivacy();
      // 获取存的用户信息
      this.getDetails();
      this.getStrengthsList();
    },
    methods: {
      showTab(item){  //点击选择个人强项
        if (this.selectStrengths.indexOf(item.id) == -1) {
          this.selectStrengths.push(item.id);
        } else {
          let index = this.selectStrengths.indexOf(item.id);
          this.selectStrengths.splice(index, 1);
        }
      },
      async getStrengthsList() {  //获取个人强项
        try {
          let data = {}
          const res = await this.$http.strengthsList(data);
          if (res.code == 200) {
            this.strengthsList = res.result;
          } else {
            this.$message(res.message);
          }
        } catch (e) {

          throw e
        }
      },
      showPrivacy() {
        this.privacyAgreement = true;
      },
      async getPrivacy() {
        try {
          let data = {
            queryType: 1
          }
          const res = await this.$http.goAgreement(data)
          if (res.code == 200) {
            let mycontent;
            if (res.result.length && res.result.length > 0) {
              mycontent = res.result[0].articleContent;
            }
            mycontent = mycontent.replace(/\<img/gi, '<img class="rich-img"');
            this.showContent = mycontent;
          } else {
            this.$message(res.message);
          }
        } catch (e) {
          throw e
        }
      },
      // 仅保存
      async goPreservation() {
        try {
          let id = sessionStorage.getItem('channelId')
          let data = {}
          let list = [...this.selectStrengths];
          if(id!=null){
             data = {
              id: this.id,
              name: this.name,
              sex: this.sex,
              idFront: this.idFront,
              experience:this.experience,  //工作经验
              strengths:list.join(","),   //个人强项
              idReverse: this.idReverse,
              idNumber: this.idNumber,
              bankNumber: this.bankNumber,
              bankName: this.bankName,
              bankBranch: this.bankBranch,
              accountName: this.accountName,
              identity: this.identity,
              belong: this.belong,
              email: this.email,
              addressDetail: this.addressDetail,
              detail: this.detail,
              certificate: this.certificate,
              submitStatus: 1,
              idType:this.idType,  //新增的证件类型
              channelId:id,   //渠道id
            }
          }else{
            data = {
              id: this.id,
              name: this.name,
              sex: this.sex,
              idFront: this.idFront,
              experience:this.experience,  //工作经验
              strengths:list.join(","),   //个人强项
              idReverse: this.idReverse,
              idNumber: this.idNumber,
              bankNumber: this.bankNumber,
              bankName: this.bankName,
              bankBranch: this.bankBranch,
              accountName: this.accountName,
              identity: this.identity,
              belong: this.belong,
              email: this.email,
              addressDetail: this.addressDetail,
              detail: this.detail,
              certificate: this.certificate,
              submitStatus: 1,
              idType:this.idType,  //新增的证件类型
            }
          }

          const res = await this.$http.designerAdd(data);
          console.log(res)
          if (res.code == 200) {
            this.$message.success(res.message, 1000)
          }
        } catch (e) {
          //TODO handle the exception
        }
      },
      change() {
          if(this.timeout){
                 clearTimeout(this.timeout)
           }
           this.timeout = setTimeout(() => {
                    this.goExamine()
           }, 500);
      },
      // 提交审核
      async goExamine() {
        try {
         let id = sessionStorage.getItem('channelId')
         let list = [...this.selectStrengths];
         let data = {}
          if(id!=null){
             data = {
              id: this.id,
              name: this.name,
              sex: this.sex,
              idFront: this.idFront,
              experience:this.experience,  //工作经验
              strengths:list.join(","),   //个人强项
              idReverse: this.idReverse,
              idNumber: this.idNumber,
              bankNumber: this.bankNumber,
              bankName: this.bankName,
              bankBranch: this.bankBranch,
              accountName: this.accountName,
              identity: this.identity,
              belong: this.belong,
              email: this.email,
              addressDetail: this.addressDetail,
              detail: this.detail,
              certificate: this.certificate,
              submitStatus: 2,
              idType:this.idType,
               channelId:id,   //渠道id
              // isShow: this.isShow
            }
          }else{
             data = {
              id: this.id,
              name: this.name,
              sex: this.sex,
              idFront: this.idFront,
              experience:this.experience,  //工作经验
              strengths:list.join(","),   //个人强项
              idReverse: this.idReverse,
              idNumber: this.idNumber,
              bankNumber: this.bankNumber,
              bankName: this.bankName,
              bankBranch: this.bankBranch,
              accountName: this.accountName,
              identity: this.identity,
              belong: this.belong,
              email: this.email,
              addressDetail: this.addressDetail,
              detail: this.detail,
              certificate: this.certificate,
              submitStatus: 2,
              idType:this.idType,
              // isShow: this.isShow
            }
          }

          if(this.email){
            let reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
            if (!reg.test(this.email)) {
              // this.identity = ''
              this.$message.warning('你输入的邮箱地址不正确')
              return false
              // this.isTrue = true;
            }
          }
          if(this.idNumber){
            if(this.idType==1){
              let reg2 = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
              if (!reg2.test(this.idNumber)) {
                this.$message.warning('你输入的身份证号码格式不正确')
                return false
              }
            }else if(this.idType==2){
              let reg2 = /^([A-Z]\d{6,10}(\(\w{1}\))?)$/
              if (!reg2.test(this.idNumber)) {
                this.$message.warning('你输入的港澳通行证号码格式不正确')
                return false
              }
            }else if(this.idType==3){
              let reg2 = /^\d{8}|^[a-zA-Z0-9]{10}|^\d{18}$/
              if (!reg2.test(this.idNumber)) {
                this.$message.warning('你输入的台胞证号码格式不正确')
                return false
              }
            }else if(this.idType==4){
              let reg2 = /^([EK]\d{8}|(SE|DE|PE|MA)\d{7})$/
              if (!reg2.test(this.idNumber)) {
                this.$message.warning('你输入的护照号格式不正确')
                return false
              }
            }

          }


          if (this.isShow == false) {
            this.$message.warning('请同意隐私协议')
            return false
          }


          if ((this.name && this.sex && this.idNumber && this.idType!=0  &&
             this.identity  && this.addressDetail && this.experience && this.selectStrengths.length>0 )) {
              if(this.isShow == false){
                this.$message.warning('请勾选阅读协议')
                return
              }
             if(!this.belong && this.identity == 3){
               this.$message.warning('请输入公司名称')
               return false
             }else{
               let res = await this.$http.designerAdd(data)
               if (res.code == 200) {
                 this.$message.success('提交成功', 1000)
                 this.$router.push({
                   path: "/userInfo/userInfo"
                 })
               } else {
                 this.$message.error(res.message, 1000)
               }
             }


          } else {
            this.$message.warning('请填写必填项')
            return
          }

        } catch (e) {
          throw e;
        }
        // if (this.isShow == false) {
        //   this.$message.warning('请同意隐私协议')
        //   return
        // }
      },
      // 请勾选隐私协议
      sureChange(e) {
        // console.log(this.isShow)
        if (this.isShow == false) {
          console.log(this.isShow)
          e.target.style.backgroundColor = '#409eff';
          this.isShow = true;
          console.log(this.isShow, 'ooooo')
        } else {
          e.target.style.backgroundColor = 'white';
          this.isShow = false;
          console.log(this.isShow, 'hhhh')
        }
      },
      sureChange2() {
        document.getElementById('show').click();
      },
      //获取保存数据
      async getDetails() {
        let userInfo = JSON.parse(localStorage.getItem('userInfo'))
        try {
          const res = await this.$http.getDetails(userInfo.id)
          console.log(res)
          if (res.code == 200) {
            this.userInfo = res.result
            this.id = res.result.id
            this.name = res.result.name
            this.sex = res.result.sex
            this.experience = res.result.experience
            this.selectStrengths = res.result.strengths.split(',').map(Number)
            console.log(this.selectStrengths)
            this.idNumber = res.result.idNumber
            this.imageUrl = res.result.idFront, //身份证国徽面（正面）
            this.imageUrl2 = res.result.idReverse
            this.bankNumber = res.result.bankNumber
            this.bankName = res.result.bankName
            this.bankBranch = res.result.bankBranch
            this.accountName = res.result.accountName
            this.identity = res.result.identity
            this.belong = res.result.belong
            this.email = res.result.email,
            this.addressDetail = res.result.addressDetail
            this.detail = res.result.detail
            this.imageUrl3 = res.result.certificate,
            this.isShow = false;
            this.emailStaus = res.result.emailStatus
            this.idType = res.result.idType || "0"
            this.sureChange2();
            // console.log(this.baseImgUrl)
            // console.log(res.result.idFront)
            // console.log(this.baseImgUrl + res.result.idFront)
          } else {
            this.$message(res.message);
          }
        } catch (e) {
          throw e
        }
      },
      selectFile() {
        // console.log(111111)
        this.showPhotos = 0
        document.getElementById("fileName").click();
      },
      selectFile2() {
        // console.log(22222222222)
        this.showPhotos = 1
        document.getElementById("fileName2").click();
      },
      selectFile3() {
        // console.log(33333333333333)
        this.showPhotos = 2
        document.getElementById("fileName3").click();
      },
      async uploading(event) {
        console.log(this.showPhotos)
        let file = event.target.files[0];
        let fileName = file.name;
        let fileSize = file.size;

        if (fileName.length > 50) {
          this.$message.error('文件名称过长，请求改！', 2000)
          return false;
        }
        if (fileSize > 1024 * 1024 * 2) {
          this.$message.error('上传文件大小不能超过2M！', 2000)
          return false;
        }
        let data = {
          biz: 'temp',
          file: fileName
        }
        let formData = new FormData()
        formData.append('fileName', fileName)
        formData.append('file', file)
        let res = await manage.uploadAction('/api/common/upload', formData)
        if (res.data.code == 200) {
          this.$message.success('上传成功', 1000)
          console.log(this.showPhotos)
          if (this.showPhotos == 0) {
            // console.log('人像面1111111111111')
            this.imageUrl = res.data.message;
            this.idFront = this.imageUrl
            console.log(this.baseImgUrl + this.imageUrl)
          } else if (this.showPhotos == 1) {
            // console.log('国徽面2222222222222222')
            this.imageUrl2 = res.data.message;
            this.idReverse = this.imageUrl2
          } else {
            // console.log(33333333333)
            this.imageUrl3 = res.data.message;
            console.log(this.imageUrl3)
            this.certificate = this.imageUrl3
            console.log(this.certificate)
          }
        } else {
          this.$message.error(res.message, 1000)
        }
      },


      // 邮箱激活
      async activeClick() {

        let data = {
          email: this.email,
          id: this.id,
          emailStaus: this.emailStaus,
          name:this.name
        }
        const res = await this.$http.getEmail(data)
        console.log(res)
        if (res.success) {
          this.$message.success(res.result);
        } else {
          this.$message.warning(res.message)
        }
      },


    }
  };
</script>


<style scoped>
  .main-box {
    width: 1186px;
    background-color: white;
    margin: 90px auto;
    padding: 24px 45px 53px;
  }
  .gerTab {
    width: 100%;
    overflow: auto;
  }
  .gerTr {
    padding: 0 10px;
    height: 20px;
    border: 1px solid #707070;
    border-radius: 3px;
    cursor: pointer;
    font-size: 10px;
    text-align: center;
    line-height: 20px;
    display: inline-block;
    margin-top: 14px;
    margin-left: 9px;
    color: #3A3A3A;
    font-size: 12px;
    content: attr(placeholder);
  }
  .gerTr:empty::before{
    color:black;
    content:attr(placeholder);
  }

  .gerTrs {
    border: solid 1px #dfb876;
    color: #dfb876;
  }

  .line-title {
    font-size: 20px;
    font-weight: bold;
    color: #3A3A3A;
    text-align: center;
    display: flex;
    align-items: center;
  }

  .line-title-txt {
    width: 125px;
    flex-shrink: 0;
  }

  .line-title::before {
    width: 100%;
    content: "";
    border-bottom: 1px solid #B2B2B2;
  }

  .line-title::after {
    width: 100%;
    content: "";
    border-bottom: 1px solid #B2B2B2;
  }

  .row-line {
    width: 100%;
    display: flex;
    margin-top: 40px;
  }

  .row-left,
  .row-right {
    width: 50%;
    flex-shrink: 0;
    display: flex;
    align-items: center;
  }

  .input-class {
    width: 300px;
  }

  .input-identityClass {
    width: 900px;
  }


  .input-class /deep/ .el-input__inner {
    border-top: none;
    border-left: none;
    border-right: none;
    border-bottom: 1px solid #B2B2B2;
    border-radius: 0px;
  }

  .row-title-box {
    width: 93px;
    display: flex;
    align-items: center;
  }

  .row-title-Bankbox {
    width: 110px;
  }

  .row-title {
    margin-left: 10px;
    font-size: 14px;
    font-weight: bold;
    color: #3A3A3A;
  }

  .row-titleIdentityInfo {
    display: flex;
    flex-direction: column;
  }

  .row-lines {
    width: 1000px;
    margin-top: 40px;
  }

  .imgItem {
    display: flex;
    margin: 0 auto;
  }

  .identityPhoto {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .text {
    /* width: 105px; */
    height: 14px;
    font-size: 10px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 14px;
    color: #C7C7C7;
    margin-top: 5px;
  }

  .imgItem img {
    width: 108px;
    height: 70px;
    padding: 0 78px;
  }

  .identity-img {
    height: 70px;
    padding: 0 78px;
  }

  .red-class {
    color: #E76168;
  }

  .pdfImg {
    width: 16px;
    height: 18px;
    margin-left: 26px;
  }

  .pdfImgs {
    height: 80px;
    width: 108px;
    margin-left: 26px;
  }

  .button-code {
    /* width: 70px; */
    height: 26px;
    text-align: center;
    border: 1px solid #DFB876;
    color: #DFB876;
    font-size: 10px !important;
    padding: 0 9px;
    border-radius: 5px;
    margin-left: -80px;
    z-index: 99;
  }

  .button-active {
    height: 26px;
    text-align: center;
    border: 1px solid #DFB876;
    color: #FFFFFF;
    font-size: 10px !important;
    padding: 0 15px;
    border-radius: 5px;
    margin-left: -70px;
    z-index: 99;
    background-color: #DFB876;
  }

  .button-actived {
    height: 26px;
    text-align: center;
    color: #DFB876;
    font-size: 10px !important;
    padding: 0 15px;
    border-radius: 5px;
    margin-left: -70px;
    z-index: 99;
    outline: none;
    background-color: #C9C6C7;
    color: #fff;
    border: 1px solid #C9C6C7;
  }

  .save {
    width: 125px;
    height: 39px;
    border: 1px solid #DFB876;
    color: #DFB876;
    padding: 0;
    font-size: 15px;
    border-radius: 20px;
    outline: none;
    background-color: #fff;
  }

  .submitAudit {
    width: 125px;
    height: 39px;
    background: #DFB876;
    padding: 0;
    color: #FFFFFF;
    border-radius: 20px;
    outline: none;
    border: none;
    margin-left: 30px;
  }

  .rich-txt-box {
    padding: 80px 0 20px 0;
    box-sizing: boder-box;
    background-color: white;
    width: 1186px;
    margin: 0 auto;
  }

  .rich-txt-box /deep/ .rich-img {
    width: 100%;
  }

  .dialog-box /deep/ .el-dialog__body {
    padding: 0 0;
  }

  .sureButton {
    width: 15px;
    height: 15px;
    border: 1px solid #707070;
    border-radius: 50%;
    outline: none;
  }
</style>



// WEBPACK FOOTER //
// src/pages/userInfo/certiInfo.vue